import { colors } from "@theme/colors"

const OrderedListIcon = ({ color = colors.pureWhite, height = 20, width = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="8.5" y="6" width="7" height="1" rx="0.5" fill={color} />
      <rect x="8.5" y="9.5" width="7" height="1" rx="0.5" fill={color} />
      <rect x="8.5" y="13" width="7" height="1" rx="0.5" fill={color} />
      <path
        d="M6.67627 11H5.86963V7.78369C5.86963 7.6766 5.87077 7.5695 5.87305 7.4624C5.87533 7.35531 5.8776 7.25049 5.87988 7.14795C5.88444 7.04541 5.89014 6.94743 5.89697 6.854C5.84912 6.90641 5.78988 6.96338 5.71924 7.0249C5.65088 7.08643 5.57796 7.15023 5.50049 7.21631L4.92627 7.67432L4.52295 7.16504L6.00635 6.00293H6.67627V11Z"
        fill={color}
      />
    </svg>
  )
}

export default OrderedListIcon
